import React from 'react';
import { SimpleLoading } from './loading';
export default (loader) => (props) => {
    const LazyComponent = React.lazy(loader);
    return (<React.Suspense fallback={<SimpleLoading />}>
      <LazyComponent {...props}/>
    </React.Suspense>);
};
